import request from '@/axios'
import type {
  UserLoginType,
  AuthResponse,
  UserRegisterType,
  UsernameLoginParams,
  UsernameRegisterType
} from './types'

export const emailLoginApi = (data: UserLoginType): Promise<IResponse<AuthResponse>> => {
  console.log('email login api with param')
  console.log(data)
  return request.post({ url: '/api/v1/auth/email/login', data })
}

export const usernameLoginApi = (data: UsernameLoginParams): Promise<IResponse<AuthResponse>> => {
  console.log('username login api with param')
  console.log(data)
  return request.post({ url: '/api/v1/auth/username/login', data })
}

export const loginApi = (
  data: UserLoginType | UsernameLoginParams
): Promise<IResponse<AuthResponse>> => {
  if ('username' in data && !('email' in data)) {
    return usernameLoginApi(data as UsernameLoginParams)
  } else {
    return emailLoginApi(data as UserLoginType)
  }
}

export const emailRegisterApi = (data: UserRegisterType): Promise<IResponse> => {
  return request.post({ url: '/api/v1/auth/email/register', data })
}

export const usernameRegisterApi = (data: UsernameRegisterType): Promise<IResponse> => {
  return request.post({ url: '/api/v1/auth/username/register', data })
}

export const registerApi = (data: UserRegisterType | UsernameRegisterType): Promise<IResponse> => {
  if ('username' in data && !('email' in data)) {
    return usernameRegisterApi(data as UsernameRegisterType)
  } else {
    return emailRegisterApi(data as UserRegisterType)
  }
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.post({ url: '/api/v1/auth/logout' })
}
